import { Button } from "@mui/material";
import React from "react";

export default function SocialButton({ children = "" }) {
  return (
    <Button
      variant="outlined"
      className="border-gray-300 p-4 transition-all duration-300 hover:shadow-logo"
    >
      {children}
    </Button>
  );
}
